import * as React from 'react';
import { useContext } from 'react';
import {
  BrowserRouter as Router,
  Routes as ReactRoutes,
  Route,
  Navigate,
} from 'react-router-dom';
import Home from './pages/Home/Home';
import NotationManagement from './pages/Management/Notation/NotationManagement';
import NotationCategories from './pages/Settings/NotationCategories/NotationCategories';
import Groups from './pages/Groups/Groups';
import NotationWidget from './pages/Settings/NotationWidget/NotationWidget';
import Connections from './pages/Management/UserManagement/Pages/Connections/Connections';
import UserManagement from './pages/Management/UserManagement/UserManagement';
import ViewAllSettings from './pages/Settings/ViewAllSettings/ViewAllSettings';
import EmailOverview from './pages/Support/EmailOverview/EmailOverview';
import LaunchDarklyContext from './shared-components/contexts/LaunchDarklyContext';
import UserContext from './shared-components/contexts/UserContext';
import ErrorPage from './shared-components/ErrorPage';
import PageContainer from './shared-components/PageContainer';
import NotationDetails from './shared-pages/NotationDetails/NotationDetails';
import CookieService from './shared-services/CookieService';
import NotationEmbed from './Widgets/Notation/NotationEmbed';
import NotationSelect from './Widgets/Notation/NotationSelect';
import UserImport from './pages/Support/UserImports/UserImport';

interface IRoutesProperties {
  contextRoot: string;
  federationProvider: string;
}

const Routes = (props: IRoutesProperties) => {
  const user = useContext(UserContext);
  const launchDarkly = useContext(LaunchDarklyContext);

  const beaconHomeOptOutCookie = !launchDarkly['home-can-opt-out']
    ? false
    : CookieService.Get('BeaconHomeOptOut') === 'true';

  return location.pathname.indexOf('/widget/') < 0 ? (
    <Router basename={props.contextRoot}>
      <PageContainer federationProvider={props.federationProvider}>
        <ReactRoutes>
          <>
            <Route path="/">
              <Route path="" element={<Home />} />
              <Route
                path=":notationType/:id/details/"
                element={<NotationDetails />}
              />
            </Route>
            <Route path="/groups" element={<Groups />} />
          </>

          {user.isExecutive && (
            <>
              <Route path="management">
                <Route path="notation">
                  <Route path="" element={<NotationManagement />} />
                  <Route
                    path=":notationType/:id/details/"
                    element={<NotationDetails />}
                  />
                </Route>
                <Route path="users">
                  <Route path="" element={<UserManagement />} />
                  <Route
                    path=":externalId/connections/"
                    element={<Connections />}
                  />
                </Route>

                {/* Redirects for moved pages */}
                <Route
                  path="categories"
                  element={
                    <Navigate to="/settings/notation/categories" replace />
                  }
                />
                <Route
                  path="connections"
                  element={<Navigate to="/management/users" replace />}
                />
                <Route
                  path="notationwidget"
                  element={<Navigate to="/settings/notation/widget" replace />}
                />
              </Route>
            </>
          )}

          {user.isAdministrator && (
            <>
              <Route path="settings">
                <Route path="" element={<ViewAllSettings />} />

                <Route path="notation">
                  <Route
                    path=""
                    element={<Navigate to="/settings" replace />}
                  />

                  <Route path="categories" element={<NotationCategories />} />
                  <Route path="widget" element={<NotationWidget />} />
                </Route>
              </Route>
            </>
          )}

          {user.isSupport && launchDarkly['email-overview'] && (
            <Route path="/support/emailoverview" element={<EmailOverview />} />
          )}

          {user.isSupport && launchDarkly['support-import-users'] && (
            <Route path="/support/userimport" element={<UserImport />} />
          )}

          <Route
            path="*"
            element={<ErrorPage statusCode={404} message="Page Not Found" />}
          />
        </ReactRoutes>
      </PageContainer>
    </Router>
  ) : (
    <Router basename={props.contextRoot}>
      <main id="main-content">
        <ReactRoutes>
          {/* Stuff that shouldn't render topbar */}
          <Route path="/widget/Notation/Select" element={<NotationSelect />} />
          <Route path="/widget/Notation" element={<NotationEmbed />} />
        </ReactRoutes>
      </main>
    </Router>
  );
};

export default Routes;
